
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRot as ObiRotElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rot.js';
 
 
 

 
 export const ObiRot = createComponent({
   react: React,
   tagName: 'obi-rot',
   elementClass: ObiRotElement,
   events: {
     
   }
  });
 
 